import React, { useEffect, useState } from "react";
import axios from "axios";
import { withRouter,useHistory } from "react-router-dom";
import "./BusinessAutoComplete.css";
import i18next from 'i18next';


const BusinessAutoComplete = (props) => {
    const { placeholder, selectedOption, searchQuery, onSearchChange } = props;
    const [searchResults, setSearchResults] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);


    
    // Fetch and filter data based on selectedOption and searchQuery
    const fetchData = async () => {
        if (!selectedOption || searchQuery.length < 2) {
            setSearchResults([]);
            setShowSuggestions(false);
            return;
        }
console.log('selectedOption',selectedOption)

        let url = "";
        switch (selectedOption) {
            case "Name":
                url = `${process.env.REACT_APP_BASE_URL}/web/api/v1/search/names?query=${searchQuery}`;
                break;
            case "Country":
                url = `${process.env.REACT_APP_BASE_URL}/web/api/v1/search/countries?query=${searchQuery}`;
                break;
            case "City":
                url = `${process.env.REACT_APP_BASE_URL}/web/api/v1/search/cities?query=${searchQuery}`;
                break;
            case "Category":
                url = `${process.env.REACT_APP_BASE_URL}/web/api/v1/search/categories?query=${searchQuery}`;
                break;
            default:
                return;
        }

        try {
            const response = await axios.get(url);
            setSearchResults(response.data);
            setShowSuggestions(true);
        } catch (error) {
            console.error("Error fetching data", error);
            setSearchResults([]); // Ensure old suggestions are cleared on error
            setShowSuggestions(true); // Show the suggestion list even when there's an error


        }
    };

    useEffect(() => {
        fetchData();
    }, [searchQuery, selectedOption]);

    const history = useHistory();  


    
    

    const handleSuggestionClick = (suggestion, name) => {
        // onSearchChange(suggestion);
        console.log('suggestin',suggestion);
        
        // onSearchChange(suggestion); // Update input value
        // setSearchResults([]); // Clear suggestions
        // setShowSuggestions(false); // Hide suggestions dropdown
    // if(selectedOption === "Category"){
    //     console.log('category',name)
    //     onSearchChange(name.name); // Update input value
    //     setSearchResults([]); // Clear suggestions
    //     setShowSuggestions(false); // Hide suggestions dropdown
    //     history.push(`/business/search-results?query=${encodeURIComponent(suggestion)}&type=${selectedOption}`);
    // }else{
    //     onSearchChange(name); // Update input value
    //     setSearchResults([]); // Clear suggestions
    //     setShowSuggestions(false); 
    //     history.push(`/business/search-results?query=${encodeURIComponent(suggestion)}&type=${selectedOption}`);

    // }

    if (selectedOption === "Category") {
        onSearchChange(name.name);
    } else {
        onSearchChange(name);
    }

    setSearchResults([]);
    setShowSuggestions(false);
    history.push(`/business/search-results?query=${encodeURIComponent(suggestion)}&type=${selectedOption}`);



    
    };

    return (
        <div className="autocomplete-container">
            <input
                type="text"
                placeholder={placeholder}
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                onFocus={() => setShowSuggestions(true)}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                className="search-input"
            />
    
            {showSuggestions && searchResults.length > 0 ? (
                <ul className="suggestions-list">
                    {searchResults.map((result, index) => {
                        // Extract relevant data
                        const name =
                            selectedOption === "Name" ? result.bookedName :
                            selectedOption === "Country" ? result.country :
                            selectedOption === "City" ? result.city :
                            selectedOption === "Category" ? result.mainCategory :
                            "";
    
                        // Extract the first image (if available)
                        const imageUrl = result.images && result.images.length > 0
                            // ? `https://services.hitasoft.in/juan/public/img/bookings/${result.images[0]}`
                            ? `https://emprende.net/public/img/bookings/${result.images[0]}`
                            : "/default-placeholder.png";
    
                        return (
                            <li key={index} className="suggestion-item" onClick={() => handleSuggestionClick(result._id, name)}>
                                <div className="suggestion-content">
                                    <img src={imageUrl} alt={name} className="suggestion-image" />
                                    <div className="suggestion-text">
                                        {selectedOption === "Category" ? result.mainCategory?.name : name}
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            ) : (
                showSuggestions && searchQuery.length >= 2 && (
                <div className="no-suggestions suggestions">
                    <em>{i18next.t("No suggestions, you're on your own!")}</em>
                </div>
                )
            )}
        </div>
    );
    
};

export default withRouter(BusinessAutoComplete);
